import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import Quiz1 from "./Quizzes/AdhdQuiz";
import Quiz2 from "./Quizzes/AutismQuiz";
import Quiz3 from "./Quizzes/NarcissismQuiz";
import ResultPage from "./Quizzes/ResultPage";
import ResultPageAutism from "./Quizzes/ResultPageAutism";
import ResultPageNarcissism from "./Quizzes/ResultPageNarcissism";

function App() {
    return (
        <Router>
            <div className="App">
                <ConditionalNav />
                <Routes>
                    <Route path="/quiz1" element={<Quiz1 />} />
                    <Route path="/quiz2" element={<Quiz2 />} />
                    <Route path="/quiz3" element={<Quiz3 />} />
                    <Route path="/result" element={<ResultPage />} />
                    <Route path="/autismResult" element={<ResultPageAutism />} />
                    <Route path="/narcissismResult" element={<ResultPageNarcissism />} />
                </Routes>
            </div>
        </Router>
    );
}

function ConditionalNav() {
    const location = useLocation();
    return (
        location.pathname === "/" && (
            <nav>
                <ul>
                    <li>
                        <Link to="/quiz1">ADHD</Link>
                    </li>
                    <li>
                        <Link to="/quiz2">Autism</Link>
                    </li>
                    <li>
                        <Link to="/quiz3">Narcissism</Link>
                    </li>
                </ul>
            </nav>
        )
    );
}

export default App;